import script from "./detailModule.vue?vue&type=script&setup=true&lang=js"
export * from "./detailModule.vue?vue&type=script&setup=true&lang=js"

import "./detailModule.vue?vue&type=style&index=0&id=b2cc43ca&lang=less"

const __exports__ = script;

export default __exports__